<div class="hotel-search" *ngIf="isMobile">
  <div class="hotel-search-content" [class.mobile-results]="isResults" [class.detail-mobile]="isByHoursDetail">
    <div class="message-info" *ngIf="showMessageInfo">
      <span class="message-info__title">{{'SEARCH_MODULE.BYHOURS_TITLE' | transloco}}</span>
      <span class="message-info__subtitle">{{'SEARCH_MODULE.BYHOURS_SUBTITLE' | transloco}}</span>
    </div>
    <app-search-input-destination
      *ngIf="!isByHoursDetail"
      [isMobile]="isMobile"
      [searchType]="searchType"
      [icon]="icons.Location"
      [autofocus]="true"
      [place]="destinationHotelPlace$ | async"
      [placeType]="arrival"
      [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION_MOBILE' | transloco"
      [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.TO_MOBILE' | transloco"
      [showError]="isPlaceSelectedEmpty"
      [autoCompletePlaces]="autocompleteDestinationPlaces$ | async"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
      (selectDestination)="selectPlace($event)"
      (showSearchInput)="showDestination.emit($event)"
      (inputChanged)="placeInputChanged($event)"
      (locationNotFoundEvent)="locationNotFoundEvent($event)"
      (removeAutoCompletePlaces)="clearAutocompletePlaces()"
      (popularAmplitudeEvent)="popularSelectedEvent($event)"
      (selectSimpleDestination)="selectPlace($event)">
    </app-search-input-destination>
    <div class="hotel-calendar-inputs">
      <div class="hotel-calendar-input departure">
        <app-search-bar-input
          [isMobile]="isMobile"
          [searchType]="searchType"
          [label]="'SEARCH_MODULE.LOCATION_SEARCH.ENTRY' | transloco"
          [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.ENTRY' | transloco"
          [value]="departureDate | hotelSearchDate"
          [icon]="icons.Calendar"
          [swapPlaceholder]="true"
          [readOnly]="true"
          [showError]="isDepartureDateEmpty"
          (isFocus)="showMobileCalendar(calendarField.departure)">
        </app-search-bar-input>
      </div>
    </div>
    <app-byhours-filter-hour
      *ngIf="!isByHoursDetail"
      [hourType]="hourType"
    ></app-byhours-filter-hour>
  </div>
  <div class="search-byhours" [class.mobile-search]="isResults">
    <app-fixed-surface
      [boxShadow]="true">
      <app-ds-button 
        [isLoading]="loadSearchData" 
        [isDisabled]="loadSearchData" 
        [labels]="{ ButtonLabel: 'BUTTONS.SEARCH' | transloco }"
        (clickEvent)="navigateToSearch()">
      </app-ds-button>
    </app-fixed-surface>
  </div>
</div>